import { actions } from '../../../reducers/assignment.reducer'

/**
 * Handler for optimistic deletion of patterns
 * @param {Object} param0 Query parameters
 * @param {Object} param1 API utilities
 */
export const handleDeletePatternOnQueryStarted = async ({ patternId }, { dispatch, getState, queryFulfilled }) => {
    // Get current patterns
    const { assignment } = getState();
    const currentPatterns = assignment.descriptionsSuggestedBySemanticDiscovery;
    
    // Optimistically update by removing the pattern
    dispatch(actions.setDescriptionsSuggestedBySemanticDiscovery(
        currentPatterns.filter(pattern => pattern.id !== patternId)
    ));
    
    try {
        // Wait for the query to complete
        await queryFulfilled;
    } catch (error) {
        // If request fails, revert to previous state
        dispatch(actions.setDescriptionsSuggestedBySemanticDiscovery(currentPatterns));
        console.error('Error removing pattern:', error);
    }
}
